export default __webpack_public_path__ + "images/AK.82dda4a.png";